
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ReactBootstrapModal } from 'shared/components/ReactModal';


interface Props {
  className?: string;
  disabled: boolean;
  onRemove: () => Promise<void>;
}

export const RemoveItemBtn = (props: Props) => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  return (
    <>
      <button 
        type="button"
        className={props.className} 
        disabled={props.disabled}
        title="Remove item"
        onClick={()=> {
          setShowConfirm(true);
        }}
      >
        {/* <ModalCloseIcon/> */}
        <FontAwesomeIcon icon={faTrashAlt}/>
      </button>
      <ReactBootstrapModal
        title="Remove item"
        isOpen={showConfirm}
        onRequestClose={() => setShowConfirm(false)}
        className="text-center"
      >
        <p className="mt-4 lead">Are you sure you want to remove this item from your cart?</p>
        <button 
          className="btn btn-outline-secondary mr-2 mb-2" 
          disabled={props.disabled} 
          type="button" onClick={() => setShowConfirm(false)}
        >
            Return to application
        </button>
        <button 
          className="btn btn-danger mr-2 mb-2" 
          disabled={props.disabled} 
          type="button" 
          onClick={async () => {
            setShowConfirm(false);
            await props.onRemove();
          }}
        >
          Remove item
        </button>
      </ReactBootstrapModal>
    </>
  );
}